import React, { useState, useEffect, useRef } from 'react';
import { Modal, Button } from 'react-bootstrap';
import Tabs from '../components/ui/Tabs';
import GeneralInfoForm from '../components/forms/GeneralInfoForm';
import PersonalInfo from '../components/forms/PersonalInfo';
import JobDetails from '../components/forms/JobDetails';
import Education from '../components/forms/Education';
import BankInfo from '../components/forms/BankInfo';
import SalaryContract from '../components/forms/SalaryContract';
import Compliance from '../components/forms/Compliance';
import ExitDetails from '../components/forms/ExitDetails';
import Experience from '../components/forms/Experience';
import Documents from '../components/forms/Documents';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
// Mapping helpers (customize as needed)
function mapEmployeeToJobDetails(employee) {
     return {
          department_category: employee?.department_category || '',
          main_department: employee?.main_department || '',
          sub_department: employee?.sub_department || '',
          designation_name: employee?.designation_name || '',
          grade_name: employee?.grade_name || '',
          position: employee?.position || '',
          reporting_manager_name: employee?.reporting_manager_name || '',
          reporting_manager_empcode: employee?.reporting_manager_empcode || '',
          functional_manager_name: employee?.functional_manager_name || '',
          skip_level_manager_empcode: employee?.skip_level_manager_empcode || '',
          shift_description: employee?.shift_description || '',
          shift_description_1: employee?.shift_description_1 || '',
          shift_description_2: employee?.shift_description_2 || '',
          week_off: employee?.week_off || '',
          isLeaveApplicable: employee?.isLeaveApplicable || 'N',
          work_type: employee?.work_type || '',
     };
}
function mapEmployeeToBankInfo(employee) {
     return {
          bank_account_name: employee?.bank_account_name || '',
          bank_account_number: employee?.bank_account_number || '',
          ifsc_code: employee?.ifsc_code || '',
          bank_name: employee?.bank_name || '',
     };
}
function mapEmployeeToSalaryContract(employee) {
     return {
          ctc: employee?.ctc || '',
          latest_agreement_valid_date: employee?.latest_agreement_valid_date || '',
          latest_agreement_end_date: employee?.latest_agreement_end_date || '',
          latest_contract_fee_revision_amount: employee?.latest_contract_fee_revision_amount || '',
     };
}
function mapEmployeeToCompliance(employee) {
     return {
          aadhar_number: employee?.aadhar_number || '',
          pan_number: employee?.pan_number || '',
          tds_status: employee?.tds_status || '',
     };
}
function mapEmployeeToExitDetails(employee) {
     return {
          resignation: employee?.resignation || '',
          resignation_date: employee?.resignation_date || '',
          relieving_date: employee?.relieving_date || '',
          last_working_date: employee?.last_working_date || '',
          last_pay_date: employee?.last_pay_date || '',
          separation_status: employee?.separation_status || '',
          notice_period: employee?.notice_period || '',
          resignation_reason: employee?.resignation_reason || ''
     };
}
function mapEmployeeToExperience(employee) {
     return {
          experiences: Array.isArray(employee?.experiences) && employee.experiences.length > 0
               ? employee.experiences
               : [{ previous_company: '', previous_designation: '', previous_experience_years: '' }],
     };
}

// Initial state templates for each tab
const initialGeneralInfo = {
     employee_code: '',
     emp_type: '',
     employee_name: '',
     designation: '',
     department: '',
     joining_date: '',
     employment_type: '',
     city_name: '',
     cluster: '',
     location_name: '',
     company: '',
     pay_group: '',
     total_experience: '',
     split_shift: 'N',
};
const initialPersonalInfo = {
     email: '',
     mobile: '',
     emergency_contact: '',
     dob: '',
     gender: '',
     father_husband_name: '',
     marital_status: '',
     blood_group: '',
     religion: '',
     caste: '',
};
const initialJobDetails = {
     department_category: '',
     main_department: '',
     sub_department: '',
     designation_name: '',
     grade_name: '',
     position: '',
     reporting_manager_name: '',
     reporting_manager_empcode: '',
     functional_manager_name: '',
     skip_level_manager_empcode: '',
     shift_description: '',
     shift_description_1: '',
     shift_description_2: '',
     week_off: '',
     isLeaveApplicable: 'N',
     work_type: '',
};
const initialEducation = {
     educations: [
          {
               highest_qualification: '',
               university: '',
               passing_year: ''
          }
     ]
};
const initialBankInfo = {
     bank_account_name: '',
     bank_account_number: '',
     ifsc_code: '',
     bank_name: ''
};
const initialSalaryContract = {
     ctc: '',
     agreement_valid_date: '',
     agreement_end_date: '',
     contract_fee_revision_amount: ''
};
const initialCompliance = {
     aadhar_number: '',
     pan_number: '',
     tds_status: ''
};
const initialExitDetails = {
     resignation: '',
     resignation_date: '',
     relieving_date: '',
     last_working_date: '',
     last_pay_date: '',
     separation_status: '',
     notice_period: '',
     resignation_reason: ''
};
const initialExperience = {
     experiences: [
          {
               previous_company: '',
               previous_designation: '',
               previous_experience_years: ''
          }
     ]
};
const initialDocuments = { files: [], info: [] };

// Mapping helpers (customize as needed)
function mapEmployeeToGeneralInfo(employee) {
     return {
          employee_code: employee?.employee_code || '',
          emp_type: employee?.emp_type || '',
          employee_name: employee?.employee_name || '',
          designation: employee?.designation || '',
          department: employee?.department || '',
          joining_date: employee?.joining_date || '',
          employment_type: employee?.employment_type || '',
          company: employee?.company || '',
          pay_group: employee?.pay_group || '',
          total_experience: employee?.total_experience || '',
          city_name: employee?.city_name || '',
          cluster: employee?.cluster || '',
          location_name: employee?.location_name || '',
          split_shift: employee?.split_shift || '',
     };
}
function mapEmployeeToPersonalInfo(employee) {
     return {
          email: employee?.email || employee?.mail || '',
          mobile: employee?.mobile || '',
          emergency_contact: employee?.emergency_contact || '',
          dob: employee?.dob || employee?.dob || '',
          gender: employee?.gender || '',
          father_husband_name: employee?.father_husband_name || employee?.father_husband_name || '',
          marital_status: employee?.marital_status || '',
          blood_group: employee?.blood_group || '',
          religion: employee?.religion || '',
          caste: employee?.caste || '',


     };
}
// ...add similar mapping functions for other tabs as needed

const EditEmployeeModal = ({ show, onClose, employee, employees, onSave }) => {
     // State for each tab
     const [editGeneralInfo, setEditGeneralInfo] = useState(initialGeneralInfo);
     const [editPersonalInfo, setEditPersonalInfo] = useState(initialPersonalInfo);
     const [editJobDetails, setEditJobDetails] = useState(initialJobDetails);
     const [editEducation, setEditEducation] = useState(initialEducation);
     const [editBankInfo, setEditBankInfo] = useState(initialBankInfo);
     const [editSalaryContract, setEditSalaryContract] = useState(initialSalaryContract);
     const [editCompliance, setEditCompliance] = useState(initialCompliance);
     const [editExitDetails, setEditExitDetails] = useState(initialExitDetails);
     const [editExperience, setEditExperience] = useState(initialExperience);
     const [editDocuments, setEditDocuments] = useState(initialDocuments);

     // Refs for validation
     const editGeneralInfoFormRef = useRef();
     const editPersonalInfoFormRef = useRef();
     const editJobDetailsFormRef = useRef();
     const editEducationFormRef = useRef();
     const editBankInfoFormRef = useRef();
     const editSalaryContractFormRef = useRef();
     const editComplianceFormRef = useRef();
     const editExitDetailsFormRef = useRef();
     const editExperienceFormRef = useRef();
     const editDocumentsFormRef = useRef();

     // Set initial state when employee changes
     useEffect(() => {
          if (employee) {
               setEditGeneralInfo(mapEmployeeToGeneralInfo(employee));
               setEditPersonalInfo(mapEmployeeToPersonalInfo(employee));
               setEditJobDetails(mapEmployeeToJobDetails(employee));
               setEditEducation({
                    educations: Array.isArray(employee.educations) && employee.educations.length > 0
                         ? employee.educations
                         : [{ highest_qualification: '', university: '', passing_year: '' }]
               });
               setEditBankInfo(mapEmployeeToBankInfo(employee));
               setEditSalaryContract(mapEmployeeToSalaryContract(employee));
               setEditCompliance(mapEmployeeToCompliance(employee));
               setEditExitDetails(mapEmployeeToExitDetails(employee));
               setEditExperience(mapEmployeeToExperience(employee));
               setEditDocuments(employee.documents || initialDocuments);
          } else {
               setEditGeneralInfo(initialGeneralInfo);
               setEditPersonalInfo(initialPersonalInfo);
               setEditJobDetails(initialJobDetails);
               setEditEducation(initialEducation);
               setEditBankInfo(initialBankInfo);
               setEditSalaryContract(initialSalaryContract);
               setEditCompliance(initialCompliance);
               setEditExitDetails(initialExitDetails);
               setEditExperience(initialExperience);
               setEditDocuments(initialDocuments);
          }
     }, [employee, show]);

     // Save handler (customize API call as needed)

     const handleEditSave = async () => {
          // Show loading toast
          const loadingToast = toast.loading('Updating employee...');

          // Get JWT token
          const token = sessionStorage.getItem('token') || localStorage.getItem('authToken');
          if (!token) {
               toast.update(loadingToast, { render: 'Authentication token not found. Please login again.', type: 'error', isLoading: false, autoClose: 3000 });
               return;
          }

          // Create FormData for multipart/form-data
          const formData = new FormData();

          // Build main employee data payload
          const employeeData = {
               ...editGeneralInfo,
               ...editPersonalInfo,
               ...editJobDetails,
               ...editEducation,
               ...editBankInfo,
               ...editSalaryContract,
               ...editCompliance,
               ...editExitDetails,
               ...editExperience,
          };

          // Add employee data as JSON string
          formData.append('data', JSON.stringify(employeeData));

          // Add document files and names
          if (editDocuments.files && editDocuments.files.length > 0) {
               editDocuments.files.forEach((docRow, index) => {
                    if (docRow.file && docRow.document_name) {
                         // Add the file
                         formData.append(`files[${index}]`, docRow.file);
                         // Add the document name
                         formData.append(`document_names[${index}]`, docRow.document_name);
                    }
               });
          }

          // Use the update API endpoint
          const apiUrl = `${process.env.REACT_APP_BASE_URL}/updateEmployee/${employee.emp_id}`;

          try {
               const response = await fetch(apiUrl, {
                    method: 'POST',
                    headers: {
                         'Authorization': `Bearer ${token}`,
                         // Don't set Content-Type header - let the browser set it with boundary for FormData
                    },
                    body: formData // Send FormData instead of JSON
               });

               const result = await response.json();

               if (!response.ok || !result.status) {
                    toast.update(loadingToast, { render: result.message || 'Failed to update employee', type: 'error', isLoading: false, autoClose: 3000 });
                    return;
               }

               // Show success toast and ensure it disappears
               toast.update(loadingToast, { render: 'Employee updated successfully!', type: 'success', isLoading: false, autoClose: 2000 });

               // Call parent's onSave to refresh list before closing modal
               if (onSave) await onSave();
               // Wait for the toast to auto-close before closing the modal and dismiss any lingering toasts
               setTimeout(() => {
                    toast.dismiss();
                    if (onClose) onClose();
               }, 2100);
          } catch (error) {
               toast.update(loadingToast, { render: 'Network error. Please try again.', type: 'error', isLoading: false, autoClose: 3000 });
          }
     };

     const handleDocumentDelete = async (documentId) => {
          // Refresh employee data after document deletion
          try {
               const response = await fetch(`${process.env.REACT_APP_BASE_URL}/employee/${employee.emp_id}`, {
                    headers: {
                         'Authorization': `Bearer ${sessionStorage.getItem('token') || localStorage.getItem('authToken')}`
                    }
               });
               const result = await response.json();
               if (result.status && result.data) {
                    // Update the employee prop with fresh data
                    Object.assign(employee, result.data);
               }
          } catch (error) {
               console.error('Error refreshing employee data:', error);
          }
     };

     return (
          <>
               <ToastContainer position="top-right" />
               <Modal
                    show={show}
                    onHide={onClose}
                    animation={true}
                    backdropClassName="custom-modal-backdrop"
                    dialogClassName="animate__animated animate__fadeInRightBig customslide"
               >
                    <Modal.Header closeButton>
                         <b>Edit Employee</b>
                    </Modal.Header>
                    <Modal.Body>
                         <Tabs
                              tabs={[
                                   {
                                        label: 'Basic Info',
                                        content: <GeneralInfoForm
                                             ref={editGeneralInfoFormRef}
                                             formData={editGeneralInfo}
                                             setFormData={setEditGeneralInfo}
                                             formMode="edit"
                                             employees={employees}
                                        />
                                   },
                                   { label: 'Personal Info', content: <PersonalInfo ref={editPersonalInfoFormRef} formData={editPersonalInfo} setFormData={setEditPersonalInfo} /> },
                                   {
                                        label: 'Job Info',
                                        content: <JobDetails
                                             ref={editJobDetailsFormRef}
                                             formData={editJobDetails}
                                             setFormData={setEditJobDetails}
                                             emp_type={editGeneralInfo.emp_type}
                                             split_shift={editGeneralInfo.split_shift}
                                        />
                                   },
                                   { label: 'Education', content: <Education ref={editEducationFormRef} formData={editEducation} setFormData={setEditEducation} /> },
                                   { label: 'Bank', content: <BankInfo ref={editBankInfoFormRef} formData={editBankInfo} setFormData={setEditBankInfo} /> },
                                   { label: 'Salary / Contract', content: <SalaryContract ref={editSalaryContractFormRef} formData={editSalaryContract} setFormData={setEditSalaryContract} /> },
                                   { label: 'Compliance', content: <Compliance ref={editComplianceFormRef} formData={editCompliance} setFormData={setEditCompliance} /> },
                                   { label: 'Exit Details', content: <ExitDetails ref={editExitDetailsFormRef} formData={editExitDetails} setFormData={setEditExitDetails} /> },
                                   { label: 'Experience', content: <Experience ref={editExperienceFormRef} formData={editExperience} setFormData={setEditExperience} /> },
                                   {
                                        label: 'Documents',
                                        content: <Documents
                                             ref={editDocumentsFormRef}
                                             documents={editDocuments}
                                             setDocuments={setEditDocuments}
                                             editMode={true}
                                             uploadedDocuments={employee?.documents || []}
                                             onDocumentDelete={handleDocumentDelete}
                                        />
                                   }
                                   // { label: 'Documents', content: <Documents ref={editDocumentsFormRef} documents={editDocuments} setDocuments={setEditDocuments} /> },
                              ]}
                         />
                    </Modal.Body>
                    <Modal.Footer>
                         <Button variant="secondary" size="sm" onClick={onClose}>
                              Close
                         </Button>
                         <Button
                              variant="primary"
                              size="sm"
                              onClick={handleEditSave}
                              style={{ marginLeft: 8 }}
                         >
                              Update Employee
                         </Button>
                    </Modal.Footer>
               </Modal>
          </>
     );
};

export default EditEmployeeModal;
